/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-spotify.svg";
import diagram from "./diagram-spotify.svg";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      a: "a",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Our approach:"
          }), " In addition to working towards net zero, we’re focused on using the reach of our platform to both raise awareness of the climate crisis and drive positive change. Whether that’s through the ", _jsx(_components.a, {
            href: "https://open.spotify.com/show/1tEMiFKer7YS2A6mhbmWE1?si=230abb0a2d464e03",
            children: "podcasts we recorded at COP26"
          }), " last November, all the content in our ", _jsx(_components.a, {
            href: "https://open.spotify.com/genre/play_your_part_climate-page",
            children: "Climate Action Hub"
          }), ", or this year’s Earth Day campaign amplifying the voices of young climate advocates across the world."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I believe:"
          }), " Sustainability shouldn’t be handled on the side. To get people factoring climate into everyday decision-making, you need clear direction and a plan on how you’re going to educate teams on the challenges and make the relevant data available for all to use. Integration is the only way to drive impact for real."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’m proud that:"
          }), " We have great climate engagement across the company. Our R&D team set up a Climate Champions network to drive goal-setting and implementation. We also had climate as our theme for our annual Hack Week this year to harness the creativity of all Spotifiers. We love experimentation and seeing what works."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Spotify",
        logo: logo,
        diagram: diagram,
        children: [_jsx(_components.p, {
          children: "Unlocking the potential of human creativity by helping creative artists earn from their art—including climate storytelling."
        }), _jsx(_components.p, {
          children: "On a path to net zero by 2030, including all supplier (Scope 3) emissions."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Many of the solutions needed to solve the climate crisis already exist. ", _jsx("mark", {
            children: "We just need to find ways to implement them"
          }), " at scale."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
